import { message } from 'antd'
import {
  isSignedIn,
  isSubActive,
  useSubscriptionStore,
} from '@/stores/subscriptionStore'

/** 粗估：中文约 1.5 token/字，英文按空格；至少扣 500 */
export function estimateTokensFromText(text: string): number {
  const chars = text.replace(/\s+/g, '').length
  return Math.max(500, Math.ceil(chars * 1.5))
}

export function estimateTokensFromMessages(
  messages: { content: string }[],
): number {
  return estimateTokensFromText(messages.map((m) => m.content).join('\n'))
}

/** 生成前：须登录且额度有效 */
export function assertCanGenerate(): boolean {
  const { profile, sub } = useSubscriptionStore.getState()
  if (!isSignedIn(profile)) {
    message.warning('请先登录后再生成（右上角账号）')
    return false
  }
  if (!isSubActive(sub)) {
    message.warning('额度不足或已过期，请在账号菜单开通套餐')
    return false
  }
  return true
}

export function deductAfterGenerate(opts: {
  promptTokens?: number
  completionText?: string
  completionTokens?: number
}): number {
  const usage =
    (opts.promptTokens || 0) +
    (opts.completionTokens ||
      estimateTokensFromText(opts.completionText || ''))
  const n = Math.max(1, usage)
  useSubscriptionStore.getState().deductTokens(n)
  return n
}
